module.exports = __webpack_public_path__ + "img/edit.dbd9df9c.svg";